// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../node_modules/rescript/lib/es6/list.js";
import * as Config from "../Config.bs.js";

function getCurrency(country) {
  return country._0.currency;
}

function getCountryData(param) {
  return {
          currency: /* INR */2,
          timeZone: "Asia/Kolkata"
        };
}

var INDIA = {
  getCountryData: getCountryData
};

function getCountryData$1(param) {
  return {
          currency: /* BDT */1,
          timeZone: "Asia/Dhaka"
        };
}

var prodHostname = {
  hd: "fe-partner-server.prod.porter.bd",
  tl: /* [] */0
};

var stagingHostname = {
  hd: "fe-partner-server.staging.porter.bd",
  tl: /* [] */0
};

function getHostnames(param) {
  return List.concat({
              hd: prodHostname,
              tl: {
                hd: stagingHostname,
                tl: /* [] */0
              }
            });
}

var BD = {
  getCountryData: getCountryData$1,
  prodHostname: prodHostname,
  stagingHostname: stagingHostname,
  getHostnames: getHostnames
};

function getCountryData$2(param) {
  return {
          currency: /* AED */0,
          timeZone: "Asia/Dubai"
        };
}

var prodHostname$1 = {
  hd: "fe-partner-server.prod.porter.ae",
  tl: /* [] */0
};

var stagingHostname$1 = {
  hd: "fe-partner-server.staging.porter.ae",
  tl: /* [] */0
};

function getHostnames$1(param) {
  return List.concat({
              hd: prodHostname$1,
              tl: {
                hd: stagingHostname$1,
                tl: /* [] */0
              }
            });
}

var UAE = {
  getCountryData: getCountryData$2,
  prodHostname: prodHostname$1,
  stagingHostname: stagingHostname$1,
  getHostnames: getHostnames$1
};

function countryToString(country) {
  switch (country.TAG | 0) {
    case /* UAE */0 :
        return "uae";
    case /* BD */1 :
        return "bd";
    case /* INDIA */2 :
        return "india";
    
  }
}

function getConfig(country) {
  switch (country) {
    case /* UAE */0 :
        return {
                TAG: /* UAE */0,
                _0: {
                  currency: /* AED */0,
                  timeZone: "Asia/Dubai"
                }
              };
    case /* BD */1 :
        return {
                TAG: /* BD */1,
                _0: {
                  currency: /* BDT */1,
                  timeZone: "Asia/Dhaka"
                }
              };
    case /* INDIA */2 :
        return {
                TAG: /* INDIA */2,
                _0: {
                  currency: /* INR */2,
                  timeZone: "Asia/Kolkata"
                }
              };
    
  }
}

function getCountryConfig(country_param) {
  var tmp;
  var exit = 0;
  if (country_param !== undefined) {
    switch (country_param) {
      case "Bangladesh" :
          tmp = /* BD */1;
          break;
      case "India" :
          tmp = /* INDIA */2;
          break;
      case "UAE" :
          tmp = /* UAE */0;
          break;
      default:
        exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var match = Config.Env.infra_stack;
    switch (match) {
      case "india" :
          tmp = /* INDIA */2;
          break;
      case "uae" :
          var value = window.location.hostname.replace(/(www\.)?/g, "");
          tmp = List.mem(value, getHostnames(undefined)) ? /* BD */1 : (List.mem(value, getHostnames$1(undefined)), /* UAE */0);
          break;
      default:
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "CountryConfig.res",
                67,
                9
              ],
              Error: new Error()
            };
    }
  }
  return getConfig(tmp);
}

var defaultCountry = /* UAE */0;

export {
  defaultCountry ,
  getCurrency ,
  INDIA ,
  BD ,
  UAE ,
  countryToString ,
  getConfig ,
  getCountryConfig ,
  
}
/* Config Not a pure module */
